import DotsHorizontalIcon from '@heroicons/react/outline/esm/DotsHorizontalIcon.js'

import { Post } from '@tribeplatform/gql-client/types'
import { ButtonSize, IconButton } from '@tribeplatform/react-ui-kit/Button'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'

import { useFirstRenderContext } from '../common/ssr/index.js'
import { useI18n } from '../i18n/providers/I18nProvider.js'
import { PostActionItems } from './PostActionItems.js'
import type { PostContext } from './types.js'

export const PostOptions = ({
  post,
  size,
  context,
}: {
  post: Post
  size?: ButtonSize
  context: PostContext
}) => {
  const { $t } = useI18n()

  /**
   * @tag Vite migration
   * Dropdown produces hydration error because of prop `id` did not match.
   * As a workaround, Dropdown is initialized client-side only
   */
  const { isFirstRender } = useFirstRenderContext()

  if (isFirstRender) {
    return (
      <IconButton
        variant="tertiaryNeutral"
        size={size}
        rounded
        icon={<DotsHorizontalIcon />}
        aria-label={$t({
          defaultMessage: 'Options',
          id: 'Generics.Options',
        })}
      />
    )
  }

  return (
    <>
      <Dropdown placement="bottom-end">
        {({ open }) => (
          <>
            <Dropdown.ButtonMinimal
              aria-label={$t({
                defaultMessage: 'Options',
                id: 'Generics.Options',
              })}
            >
              <IconButton
                as="span"
                variant="tertiaryNeutral"
                size={size}
                rounded
                icon={<DotsHorizontalIcon />}
              />
            </Dropdown.ButtonMinimal>
            <PostActionItems
              post={post}
              context={context}
              showShortcuts={open}
              className="w-56"
            />
          </>
        )}
      </Dropdown>
    </>
  )
}
